import axios, { AxiosError } from 'axios';
import { useRouter } from 'next/router';
import { useQuery, UseQueryResult } from 'react-query';

export const getTable = async (
  merchantId: string,
  tableId: string
): Promise<ITableDetail | Error> => {
  try {
    const url = `/api/merchants/${merchantId}/tables/${tableId}`;
    const { data } = await axios.get(`${url}`);
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || error?.response?.data?.error || error);
  }
};

export function useTable(
  merchantId?: string,
  tableId?: string
): UseQueryResult<ITableDetail, AxiosError> {
  const router = useRouter();
  const { merchantId: merchantIdFromUrl, tableId: tableIdFromUrl } = router.query;
  const merchId = merchantId || merchantIdFromUrl;
  const tabId = tableId || tableIdFromUrl;
  return useQuery(['table', merchId, tabId], () => getTable(merchId as string, tabId as string), {
    staleTime: 1000000,
    enabled: !!merchId && !!tabId,
  });
}
